import {
  Cpu,
  BarChart2,
  PiggyBank,
  Heart,
  Lightbulb,
  Briefcase,
} from 'lucide-react';

export const careerTracks = [
  { name: 'Technology', icon: Cpu, description: "Software, data, IT, and web development." },
  { name: 'Marketing', icon: BarChart2, description: "Social media, branding, and digital advertising." },
  { name: 'Finance', icon: PiggyBank, description: "Accounting, investing, and financial planning." },
  { name: 'Healthcare', icon: Heart, description: "Medical, nursing, and health administration." },
  { name: 'Logistics', icon: Briefcase, description: "Supply chain, operations, and transportation." },
  { name: 'Enterprise Management', icon: Lightbulb, description: "Strategy, operations, and HR." },
];